import React, { useEffect, useCallback, useState} from 'react';
import {TRACK} from 'constants/object-types.js';
import {TRACK_THUMBNAIL} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';
import MultiFreezeThumbnails from 'components/freeze/MultiFreezeThumbnails.js';
import {getTrackShortName} from 'utils/getTrackShortName.js';
import {
    setTrackDragging,
    setSampleDragging} from "actions/index.js";
import {WAVEFORM, INFO} from 'constants/arrangement-modes.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import {AUDIO} from 'constants/track-types.js';
import {MULTI_SYNTH, SAMPLED_INSTRUMENT} from 'constants/instrument-types.js';
import {MULTI_FREEZE} from 'constants/track-types.js';
import PulseLoader from 'react-spinners/PulseLoader'

import '../thumbnail.scss';

const colors = new Colors();

// will only be used in TrackComponet and the bottom bar sampler browser

const DRUM_TAGS = new Set(['clap', 'tom', 'toms', 'clave', 'perc', 'snare', 'kick', 'hi-hat', 'rim', 'side-stick', 'breaks', 'sub', 'ride', 'piano', 'violin']);

const TrackThumbnail = ({
    isLoading,
    hasInner, 
    track,
    isSelectedTrack,
    onMouseDown=() => [],
    sample,
    isPad,
    draggable=true,
    onClickThumbnail,
    showingWaveform,
    className,
    showPresetName,
    setSampleDragging,
    setTrackDragging,
    children,
    hasBorder,
    scale,
}) => { 
    sample = sample || track.sample;
    let style = {
        backgroundColor: track && track.getTrackType ? colors.getColorForTrack(track) :
            sample && colors.getColorForHash(sample.getId())
    };
    if (hasBorder) {
        style.borderColor = style.backgroundColor;
    }
    let classSuffix = '';
    if (showingWaveform && track) {
        classSuffix = " showing-waveform ";
    }

    if (className) {
        classSuffix += className + " ";
    }

    if (!track && !sample) {
        return '';
    }
    let innerText =  getTrackShortName(track, sample);

    if (track && track.getObjectType && track.getObjectType() === TRACK) {
        if (track && track.getTrackType() === MULTI_FREEZE) {
            classSuffix += " is-multi ";
        }
        if (innerText === undefined || innerText==="" ) {
            if (showPresetName && track) {
                innerText = track.presetName || track.getName();
            }
        }
    }


    if (scale) {
        style.height = scale * 12 + 'px';
        style.lineHeight = scale * 12 + 'px';
        style.fontSize= scale * 6 + 'pt';
    }
    
    let inner = (
        <div
          draggable={draggable}
          onMouseDown={onMouseDown}
          onClick={onClickThumbnail}
          onDragStart={(e) => {
              e.stopPropagation();
              setSampleDragging(sample);
              setTrackDragging(track);
          }}
          onDragOver={(e) => e.preventDefault()}
          className={"pushable sound-thumbnail " + classSuffix} style={style}
        >{innerText}</div>);
    if (sample) {
        let thumbnail = sample.getThumbnail();
        if (thumbnail && thumbnail !== "") {
            inner = (
                <img
                  draggable={draggable}
                  onMouseDown={onMouseDown}
                  onDragStart={(e) => {
                      e.stopPropagation();
                      setTrackDragging(track);
                      setSampleDragging(sample);
                  }}
                  onDragOver={(e) => e.preventDefault()}
                  src={thumbnail}
                  onClick={onClickThumbnail}
                  className={"pushable youtube-thumbnail " + classSuffix}/>);
        } 
    } 

    if (hasInner && track && track.sample && track.sample.getThumbnail() !== "" &&
        track.sample.getThumbnail()) {
        hasInner = false;
    }

    if (!isPad) {
        if (track.instrument && track.instrument.getInstrumentType() === MULTI_SYNTH) {
            inner = (<img
                       onDragStart={(e) => {
                           e.stopPropagation();
                           setTrackDragging(track);
                           setSampleDragging(sample);
                       }}
                       onClick={onClickThumbnail}
                       className="pushable synth-icon" src="/synth-icon.svg"/>);
        } else if (track.getTrackType && track.getTrackType() === AUDIO) {
            inner = (<img
                       onDragStart={(e) => {
                           e.stopPropagation();
                           setTrackDragging(track);
                           setSampleDragging(sample);
                       }}
                       className="live-loop-icon" src="/live-loop-icon.svg"/>);
        }
    }

    return (
        <Documented element={undefined}>
          <div style={
              hasInner && style.backgroundColor ? {
                  backgroundColor: colors.transparent(colors.saturate(style.backgroundColor, 1), 0.65)
              } : {}}
               className="youtube-info">
            {inner}
            <PulseLoader
              className="track-loading-spinner"
              sizeUnit={"px"}
              size={10}
              color={'#123abc'}
              loading={isLoading}
            />
            {children}
          </div>
        </Documented>
    );
}

const mapStateToProps = (state, props) => {
    let track = props.track;
    if (track && track.tracks && track.tracks[0]) {
        track = track.tracks[0].track;
    }
    if (!props.track || !props.track.subSequence) {
        return {};
    }
    return {
        id: track === undefined ? 0 :
            track.sample !== undefined && track.sample.getId() !== undefined ?
            track.sample.getId() : track.presetName || (track.getName && track.getName()),
        _videoId: track && track.sample && track.sample.videoId,
        _discogsId: track && track.sample && track.sample.coverArtHash,
        isCompactMode: state.sequencer.isCompactMode && !props.isBig,
        showingWaveform: state.sequencer.showPianoRoll &&
            (state.arrangement.bottomMode === WAVEFORM ||
             state.arrangement.bottomMode === INFO),
        isLoading: props.track === undefined ? false :
            state.tracks.trackIsLoading[props.track.subSequence.id] ?
            state.tracks.trackIsLoading[props.track.subSequence.id][props.track.trackNumber] === true : false,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSampleDragging: (sample) => dispatch(setSampleDragging(sample)),
        setTrackDragging: (track) => dispatch(setTrackDragging(track)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackThumbnail);
